import React, { memo, useState, useEffect, useCallback } from 'react'

import { BrandedAlertModal } from 'components/Modal'
import type { BrandedAction } from 'components/Modal/BrandedAlertModal/BrandedAlertModal'
import { MembershipRestrictionModal } from 'components/Modal'
import ApiError from 'api/ApiError'
import { getMembershipRestrictionDialogCopy } from 'utils/membership'

interface FixedErrorProps {
	error?: ApiError | null
	onDismiss?: () => void
}

export default memo(function FixedError(
	{
		error,
		onDismiss,
	}: FixedErrorProps,
) {
	const [popupOpened, setPopupOpened] = useState(false)

	const errorMessage = error ? error.toString() : ''
	const [errorMessageCopy, setErrorMessageCopy] = useState<string>('')
	const membershipCopy = getMembershipRestrictionDialogCopy(error)

	useEffect(() => {
		if (errorMessage) {
			if (errorMessageCopy !== errorMessage) {
				setErrorMessageCopy(errorMessage)
				setPopupOpened(true)
			}
		}
	}, [errorMessage, errorMessageCopy, setErrorMessageCopy, setPopupOpened])

	const handleClose = useCallback(() => {
		setPopupOpened(false)
		onDismiss?.()
	}, [onDismiss])

	if (membershipCopy) {
		return (
			<MembershipRestrictionModal
				isOpen={popupOpened}
				copy={membershipCopy}
				onClose={handleClose}
			/>
		)
	}

	const actions: BrandedAction[] = [
		{ label: 'Ok', variant: 'primary', onClick: handleClose },
	]

	return (
		<BrandedAlertModal
			isOpen={popupOpened}
			onClose={handleClose}
			ariaLabel="Notice"
			actions={actions}
		>
			{errorMessageCopy}
		</BrandedAlertModal>
	)
})
